<template>
    <div class="d-flex justify-content-center align-items-center color-6 radius-normal border-color-6 p-2 bg-lightest my-2">
        <i :class="['ico', icon, 'color-6', 'fs-largest', 'ml-3']"></i>
        <p :class="['fs-normal', { bold: bold }]">{{ message }}</p>
    </div>
</template>

<script>
    export default {
        props: {
            message: {
                type: String,
                required: true
            },
            icon: {
                type: String,
                required: true
            },
            bold: {
                type: Boolean,
                default: false
            }
        }
    };
</script>


// WEBPACK FOOTER //
// AlertMessage.vue?5b6c31d4